// extracted by mini-css-extract-plugin
module.exports = {"section":"how-it-works_section__2xx8V","link":"how-it-works_link__2MWSw","button":"how-it-works_button__SHDc-"};